import React from "react";
import { useTranslation } from "react-i18next";

import WPDropdown from "../../../../../packages/WPDropdown";
import { WPTypography } from "../../../../../packages/WPTypography";

import "../../../../../components/SliderCardRecommended/SliderCardRecommended.scss";

const RecommendedDropdownRow = ({
  label,
  value,
  options,
  onChange,
  recommendedLabel,
}) => {
  const { t } = useTranslation();

  return (
    <div className="recommended-slider-card">
      <div className="recommended-slider-card-header recommended-slider-card-header--dropdown">
        <div className="recommended-label-group">
          <WPTypography variant="caption" className="recommended-label">
            {label}
          </WPTypography>
          {recommendedLabel != null && (
            <WPTypography
              variant="tableData"
              className="recommended-below-value"
            >
              {`${t("advanceSettings.sliderLabelMiddle")}: ${recommendedLabel}`}
            </WPTypography>
          )}
        </div>
        <div className="recommended-dropdown-wrapper">
          <WPDropdown value={value} options={options} onChange={onChange} />
        </div>
      </div>
    </div>
  );
};

export default RecommendedDropdownRow;
